<p-dialog
  [header]="displayLabel"
  [(visible)]="modalVisible"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [breakpoints]="{ '992px': '75vw', '640px': '90vw' }"
  [attr.data-e2e]="'form:footer:modal'"
  [ngClass]="{
    iframe: usedInIframe
  }"
  [style]="{
    top: usedInIframe ? (scrollPosition$ | async) + 50 + 'px' : false
  }"
  (visibleChange)="$event ? closeModal() : null"
  (onHide)="closeModal()"
>
  <iframe title="Payment plan info" class="modal-content" [src]="displayUrl | sanitize : 'RESOURCE_URL'"></iframe>
  <p-footer>
    <button class="ds-button primary" (click)="closeModal()" i18n="@@common.button.close">Close </button>
    <button class="ds-button secondary" *ngIf="displayDownloadURL" (click)="download()" i18n="@@common.button.download"
      >Download
    </button>
  </p-footer>
</p-dialog>
